var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendToNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9404_107800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9404_107800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C11.5833 14.5 11.2293 14.354 10.938 14.062C10.646 13.7707 10.5 13.4167 10.5 13C10.5 12.5833 10.646 12.2293 10.938 11.938C11.2293 11.646 11.5833 11.5 12 11.5C12.4167 11.5 12.7707 11.646 13.062 11.938C13.354 12.2293 13.5 12.5833 13.5 13C13.5 13.4167 13.354 13.7707 13.062 14.062C12.7707 14.354 12.4167 14.5 12 14.5ZM8.275 17.075C7.74167 16.5583 7.31267 15.954 6.988 15.262C6.66267 14.5707 6.5 13.8167 6.5 13C6.5 11.4667 7.03333 10.1667 8.1 9.1C9.16667 8.03333 10.4667 7.5 12 7.5C13.5333 7.5 14.8333 8.03333 15.9 9.1C16.9667 10.1667 17.5 11.4667 17.5 13C17.5 13.8167 17.3377 14.575 17.013 15.275C16.6877 15.975 16.2583 16.575 15.725 17.075L14.65 16C15.0667 15.6167 15.3957 15.1667 15.637 14.65C15.879 14.1333 16 13.5833 16 13C16 11.9 15.6083 10.9583 14.825 10.175C14.0417 9.39167 13.1 9 12 9C10.9 9 9.95833 9.39167 9.175 10.175C8.39167 10.9583 8 11.9 8 13C8 13.6 8.121 14.154 8.363 14.662C8.60433 15.1707 8.93333 15.6167 9.35 16L8.275 17.075ZM5.45 19.9C4.55 19.0167 3.83333 17.9873 3.3 16.812C2.76667 15.6373 2.5 14.3667 2.5 13C2.5 11.6833 2.75 10.4457 3.25 9.287C3.75 8.129 4.425 7.125 5.275 6.275C6.125 5.425 7.12933 4.75 8.288 4.25C9.446 3.75 10.6833 3.5 12 3.5C13.3167 3.5 14.5543 3.75 15.713 4.25C16.871 4.75 17.875 5.425 18.725 6.275C19.575 7.125 20.25 8.129 20.75 9.287C21.25 10.4457 21.5 11.6833 21.5 13C21.5 14.3667 21.2333 15.6417 20.7 16.825C20.1667 18.0083 19.45 19.0333 18.55 19.9L17.5 18.85C18.2667 18.1167 18.875 17.246 19.325 16.238C19.775 15.2293 20 14.15 20 13C20 10.7667 19.225 8.875 17.675 7.325C16.125 5.775 14.2333 5 12 5C9.76667 5 7.875 5.775 6.325 7.325C4.775 8.875 4 10.7667 4 13C4 14.15 4.225 15.225 4.675 16.225C5.125 17.225 5.74167 18.0917 6.525 18.825L5.45 19.9Z",
    fill: "#714EF5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToNetwork);
export default __webpack_public_path__ + "static/media/send-to-network.1110ad86648672b40808d045299cd69d.svg";
export { ForwardRef as ReactComponent };